var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control mobile dsf_teas_student_course" },
    [
      _c(
        "div",
        { staticClass: "search" },
        [
          _c("van-search", {
            attrs: { shape: "round", placeholder: "搜索" },
            on: { input: _vm.search },
            model: {
              value: _vm.keywords,
              callback: function ($$v) {
                _vm.keywords = $$v
              },
              expression: "keywords",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.list.length > 0
            ? _c(
                "van-pull-refresh",
                {
                  on: { refresh: _vm.onRefresh },
                  model: {
                    value: _vm.refreshing,
                    callback: function ($$v) {
                      _vm.refreshing = $$v
                    },
                    expression: "refreshing",
                  },
                },
                [
                  _c(
                    "van-list",
                    {
                      attrs: {
                        finished: _vm.finished,
                        error: _vm.error,
                        "finished-text": "没有更多了",
                      },
                      on: {
                        "update:error": function ($event) {
                          _vm.error = $event
                        },
                        load: _vm.getList,
                      },
                      model: {
                        value: _vm.loading,
                        callback: function ($$v) {
                          _vm.loading = $$v
                        },
                        expression: "loading",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "list" },
                        _vm._l(_vm.list, function (item, index) {
                          return _c(
                            "DsfMobileTeasCell",
                            {
                              key: index,
                              staticClass: "attance_cell",
                              class: _vm._f("attancingStatus")(item.state),
                              style: {
                                "margin-top": (index == 0 ? "0" : "10") + "px",
                              },
                              attrs: {
                                title: item.courseName,
                                titleEllipsis: 2,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.clickItem(item)
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "titleLeft",
                                    fn: function () {
                                      return [
                                        item.electiveValue == 1
                                          ? _c(
                                              "div",
                                              { staticClass: "xuanxiu" },
                                              [_vm._v("选修")]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "titleRight",
                                    fn: function () {
                                      return [
                                        item.state != 1 && item.state != 2
                                          ? _c("div", [
                                              item.resultValue == "1" ||
                                              item.resultValue == "5"
                                                ? _c(
                                                    "div",
                                                    { staticClass: "chuqin" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.resultText
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : "678".indexOf(
                                                    item.resultValue
                                                  ) !== -1
                                                ? _c(
                                                    "div",
                                                    { staticClass: "qingjia" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.resultText
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : item.resultValue == 9
                                                ? _c(
                                                    "div",
                                                    { staticClass: "weiqian" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.resultText
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    { staticClass: "yichang" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.resultText
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("DsfMobileTeasCellItem", {
                                attrs: {
                                  icon: "icon-shijian",
                                  value: item.courseTimeSdate,
                                },
                              }),
                              _c("DsfMobileTeasCellItem", {
                                attrs: {
                                  icon: "icon-icon-teacher",
                                  value: item.teacher ? item.teacher : "暂无",
                                },
                              }),
                              _c("DsfMobileTeasCellItem", {
                                attrs: {
                                  icon: "icon-location-hollow",
                                  value: item.place ? item.place : "暂无",
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _c("van-empty", { attrs: { description: "暂无数据" } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }